import AppConfig from '../../../Configs/AppConfig';
import { RegisterFormValues } from './RegisterForm';
import { get } from 'lodash';
import { FreemiumCourse } from '../Types/FreemiumCourse';

export const userSignup = (data: RegisterFormValues): Promise<Response> => {
  const url = `${AppConfig.PUBLIC_API_BASE_URL}/user/signup`;

  const payload = new FormData();
  payload.append('name', data.firstName);
  payload.append('surname', data.lastName);
  payload.append('email', data.email);
  payload.append('phone', data.phoneNumber);
  payload.append('termsAccepted', data.acceptPrivacy.toString());
  payload.append('instancesId', JSON.stringify(data.instancesId));

  return fetch(url, { method: 'POST', body: payload });
};

export const resendConfirmationEmail = (userId: number): Promise<Response> => {
  const url = `${AppConfig.PUBLIC_API_BASE_URL}/user/resend_email`;

  const payload = new FormData();
  payload.append('user_id', userId.toString());

  return fetch(url, { method: 'POST', body: payload });
};

export const getRegisterStatus = async (): Promise<boolean> => {
  const url = `${AppConfig.PUBLIC_API_BASE_URL}/register/status`;
  try {
    const response = await fetch(url);
    const payload = await response.json();

    if (response.status === 200) {
      return get(payload, 'data.active', false);
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};
export const getFreemiumCourses = async (): Promise<Array<FreemiumCourse>> => {
  const url = `${AppConfig.PUBLIC_API_BASE_URL}/register/courses`;
  try {
    const response = await fetch(url);
    const payload = await response.json();

    if (response.status === 200) {
      return get(payload, 'data', []);
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};
